import { useCallback, useEffect, useState } from "react";
import { PREVIEW_ACTIVE, VERSION_ACTIVE, getStatus, getVoice, listClips, listVersions } from "@/lib/myVoicesApi";

/** Replicate connection + limits (once). */
export function useVoiceStatus() {
  const [status, setStatus] = useState(null);
  useEffect(() => { getStatus().then(setStatus).catch(() => setStatus({ connected: false })); }, []);
  return status;
}

/** One voice with its training recordings and versions; polls every 4 s while anything is processing. */
export default function useVoice(id) {
  const [voice, setVoice] = useState(null);
  const [clips, setClips] = useState(null);
  const [versions, setVersions] = useState(null);
  const [error, setError] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const [v, c, vs] = await Promise.all([getVoice(id), listClips(id), listVersions(id)]);
      setVoice(v); setClips(c); setVersions(vs); setError(null);
    } catch (e) { setError(e); }
  }, [id]);
  useEffect(() => { refresh(); }, [refresh]);
  const busy = Boolean(clips?.some((c) => c.status === "processing")
    || versions?.some((v) => VERSION_ACTIVE.includes(v.status) || v.previews.some((p) => PREVIEW_ACTIVE.includes(p.status))));
  useEffect(() => {
    if (!busy) return undefined;
    const t = setInterval(refresh, 4000);
    return () => clearInterval(t);
  }, [busy, refresh]);
  return { voice, clips, versions, error, refresh };
}
